import React, { useState } from 'react';
import { Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Slide, Button } from '@material-ui/core';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const TermsOfUseModal = ({ isOpen: isOpenedByUser, handleClose }) => {
    const [isUserAcceptedTermsOfUse, setIsUserAcceptedTermsOfUse] = useState(() => localStorage.getItem('sqtrafi__isUserAcceptedTermsOfUse'));
    const isOpen = isOpenedByUser || !isUserAcceptedTermsOfUse;
    return (
        <Dialog
            open={isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            fullWidth={true}
            maxWidth="md"
            disableScrollLock={true}
        >
            <DialogTitle>
                <Typography variant="h4">Käyttöehdot</Typography>
                {/* <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button> */}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Typography variant="body1" paragraph>
                        Huomioithan ennen palvelun käyttöä, että palvelussa palautuvia tietoja ei saa käyttää millään tavalla lainvastaisesti tai sellaiseen käyttötarkoitukseen, jolla vaarannettaisiin henkilöiden yksityisyydensuojaa. Palvelun palauttamia tietoja on tarkoitus hyödyntää lähtökohtaisesti kuluttajien ajoneuvokaupan yhteydessä varmistamaan kaupan luotettavuutta ajoneuvotietojen tai omistajan osalta esimerkiksi selvittämällä, että myyjä omistaa ajoneuvon. Muiden hyväksyttyjen käyttötarkoitusten on liityttävä liikenneturvallisuuteen, ajoneuvoihin, ajoneuvoliikenteeseen tai sen aiheuttamiin ympäristöhaittoihin taikka ajoneuvon
                        kuljettamiseen. Palvelua käyttäessäsi sitoudut noudattamaan edellä mainittuja ehtoja.
                    </Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        if (!isUserAcceptedTermsOfUse && !isOpenedByUser) {
                            localStorage.setItem('sqtrafi__isUserAcceptedTermsOfUse', true);
                            setIsUserAcceptedTermsOfUse(true);
                        }
                        handleClose();
                    }}
                    color="primary"
                >
                    {isOpenedByUser ? 'Sulje' : 'Hyväksyn käyttöehdot'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TermsOfUseModal;
